import styles from "./MenuBar.module.css";
import { Link } from "react-router-dom";

const SingleLine = ({ icon, heading, link, onClick, ...other }) => {
  return link ? (
    <Link to={link} className="text-decoration-none">
      <div className={styles.singleLine} title={heading}>
        <img src={icon} className={styles.singleLineImg} alt="img" />
        <p className={styles.singleLineHeading}>{heading}</p>
      </div>
    </Link>
  ) : onClick ? (
    <div className={`${styles.singleLine} cursor-pointer`} onClick={onClick}>
      <img src={icon} className={styles.singleLineImg} alt="img" />
      <p className={styles.singleLineHeading}>{heading}</p>
    </div>
  ) : (
    <div className={`${styles.singleLine} cursor-pointer`} {...other}>
      <img src={icon} className={styles.singleLineImg} alt="img" />
      <p className={styles.singleLineHeading}>{heading}</p>
    </div>
  );
};

export default SingleLine;
